export const chunkSize = 256;
export const chunkDistance = 1024 * 5;
export const worldHeight = 2048;
